export default __webpack_public_path__ + "static/media/gallery-wip-emitter_06.871d60af.jpg";